import classNames from 'classnames';
import { MSImage } from 'common/image/ms-image.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { IADShowHide } from 'layout/utils-show-hide.js';
import { CSSProperties, ReactNode } from 'react';
import { useLayoutConfig } from 'utilities/hooks/use-layout-config.js';
import { IResponsiveImage } from 'utilities/image/image.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';

interface IProps {
  containerClass?: string;
  images: IADShowHide<IResponsiveImage>[];
}

export const getRatio = (width: number | undefined, height: number | undefined) => {
  if (isNotNullOrUndefined(width) && isNotNullOrUndefined(height)) {
    return height / width;
  }
  return 0;
};

export const ImageResponsive = ({ containerClass, images }: IProps) => {
  const image = useLayoutConfig<IADShowHide<IResponsiveImage>>(images);

  if (!image) {
    return null;
  }

  const { image: imageUrl, alt, responsive, width, height, url } = image;
  const ratio = getRatio(width, height);

  const wrapContent = (content: ReactNode) => {
    const wrapperStyle: CSSProperties = {
      flex: ratio || responsive ? '1 1 auto' : '0 1 auto',
      maxWidth: responsive ? 'none' : `${width}`,
    };

    return (
      <div className="u-flex u-flexJustifyCenter">
        {url ? (
          <LinkFactoryReactRouter
            href={url}
            style={wrapperStyle}
            className="u-block"
            target="_blank"
            rel="noopener noreferrer"
          >
            {content}
          </LinkFactoryReactRouter>
        ) : (
          <div style={wrapperStyle}>{content}</div>
        )}
      </div>
    );
  };

  const imageContainerStyle = ratio ? { paddingTop: `${ratio * 100}%` } : undefined;
  const content = (
    <div
      className={classNames({ 'img-responsive-container': ratio }, containerClass && { [containerClass]: !url })}
      style={imageContainerStyle}
    >
      <MSImage
        src={imageUrl}
        classes={classNames('img-responsive', { 'img-responsive--fill': responsive })}
        alt={alt}
      />
    </div>
  );

  return <div className={containerClass}>{wrapContent(content)}</div>;
};
